import React, { useState } from "react";

const VerifyEmailBanner = ({ onResend }) => {
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleResend = async () => {
    setLoading(true);
    await onResend();
    setSent(true);
    setLoading(false);
  };

  return (
    <div style={styles.banner}>
      <p style={styles.text}>📬 Please verify your email to unlock all features.</p>
      <button style={styles.button} onClick={handleResend} disabled={loading || sent}>
        {sent ? "✅ Sent!" : loading ? "Sending..." : "Send Verification Email"}
      </button>
    </div>
  );
};

const styles = {
  banner: {
    padding: "16px 24px",
    background: "rgba(255, 255, 255, 0.45)",
    borderRadius: "16px",
    backdropFilter: "blur(12px)",
    WebkitBackdropFilter: "blur(12px)",
    border: "1px solid rgba(255, 255, 255, 0.3)",
    boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
    color: "#000", // ✅ Changed from white to black
    fontWeight: 500,
    margin: "24px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "16px",
    position: "relative",
    zIndex: 10,
  },
  text: {
    margin: 0,
    fontSize: "16px",
    flex: 1,
    color: "#000",
  },
  button: {
    backgroundColor: "#49C3FB",
    color: "#fff",
    padding: "10px 18px",
    border: "none",
    borderRadius: "8px",
    fontWeight: 600,
    cursor: "pointer",
    transition: "background-color 0.3s ease",
  },
};

export default VerifyEmailBanner;
